
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 7l12 10","stroke":"#BABABA","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"8","stroke":"#BABABA","stroke-width":"2"}})])
          )
        }
      }
    